import classNames from 'classnames'
import React from 'react'
import { PersonLink, PersonLinkProps } from './PersonLink'

export interface TeamListProps {
  additionalClassName?: string
  gaTrackingId?: string
  scrollInLg?: boolean
  team: PersonLinkProps[]
}

// List of persons that overflows to the right and scrolls horizontally.
// Currently aligned to titles in BusinessLineContent and ParallaxHero.
export const TeamList = ({
  additionalClassName,
  gaTrackingId,
  scrollInLg = true,
  team,
}: TeamListProps) => {
  // the focus ring gets cut off as soon as horizontal scrolling is allowed
  const compensateForItemFocusRing = 'py-5 -my-5'

  return (
    <div
      className={classNames(
        'place-content-center',
        'sm:grid sm:gap-x-30 sm:grid-cols-sm',
        'md:grid-cols-md',
        'lg:grid-cols-lg',
        'xl:grid-cols-xl',
        'xxl:grid-cols-xxl',
        additionalClassName
      )}
    >
      <div className="col-span-full lg:col-start-2 lg:col-span-6 xl:col-start-2 xl:col-span-8 xxl:col-start-3 xxl:col-span-10">
        <div className="flex justify-center md:-mx-120 xl:mx-0 xxl:-mx-75">
          <div
            className={classNames(
              'grid grid-flow-col',
              {
                'grid-rows-1': team.length <= 2,
                'grid-rows-2': team.length > 2,
                'tb:grid-rows-1': team.length === 3,
                'sm:grid-rows-1': team.length === 4,
                'md:grid-rows-1': team.length === 5,
              },
              'overflow-x-scroll overflow-y-hidden hide-scrollbar',
              'focus:outline-none focus:ring focus:ring-neutral-medium-light/40',
              compensateForItemFocusRing,
              'px-20 gap-x-20 gap-y-30',
              'tb:px-30 tb:gap-x-30 tb:gap-y-45',
              'sm:px-120 sm:gap-x-60',
              {
                // Switch to flex to allow for center-justified items
                'lg:flex lg:flex-wrap lg:justify-center lg:overflow-visible': !scrollInLg,
              },
              'xl:px-0',
              'xxl:px-75 xxl:gap-x-75 xxl-gap-y-60'
            )}
          >
            {team.map((person, index) => (
              <div key={index}>
                <PersonLink {...person} gaTrackingId={gaTrackingId} variant="team-list" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}
